var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lucide lucide-code-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18 16 4-4-4-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6 8-4 4 4 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.5 4-5 16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode2);
export default __webpack_public_path__ + "static/media/code-2.6ce4a741472b160b88aaabd09a716f2a.svg";
export { ForwardRef as ReactComponent };